module.exports = __webpack_public_path__ + "images/feature/file-dir-2-e0de90c9873c0611b86f3eeab95d9bef.png";